import { Route } from "react-router-dom";
import { APP_URLS } from "../../../utils/constant";
import SettingsPaynowOptionsScreen from "../../../container/Settings/SettingsPaynowOptionsScreen";
import CreateSettingsPaynowOptions from "../../../container/Settings/SettingsPaynowOptionsScreen/CreateSettingsPaynowOptions";

const SettingsPaynowOptionsRoutes = (access = {}) => {
  const { create, view, edit = false } = access;

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.SETTINGS_PAYNOWOPTIONS.HOME}
          element={<SettingsPaynowOptionsScreen screenPermissions={access} />}
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.SETTINGS_PAYNOWOPTIONS.CREATE}
          element={<CreateSettingsPaynowOptions />}
        />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.SETTINGS_PAYNOWOPTIONS.EDIT}
          element={<CreateSettingsPaynowOptions isEdit={true} />}
        />
      )}
    </>
  );
};

export default SettingsPaynowOptionsRoutes;
